import React, { useEffect } from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import MapLocationSearch from "../../Maps/FeatureGroup/MapLocationSearch";
import MarkerClusterGroup from "react-leaflet-cluster";
import POIsPositionsPopups from "./POIsPositions/POIsPositionsPopups";
import L from "leaflet";
import { isRTL } from "../../../utils";
function RecenterMap({ lat, lon, zoom }) {
	const map = useMap();

	useEffect(() => {
		if (lat && lon && zoom) {
			map.setView([lat, lon], zoom ?? map.getZoom());
			// if zoom not passed, keep current zoom
		}
	}, [lat, lon, zoom, map]);

	return null;
}
export default function POIsMap({ POISdata, setMapId, LatLng }) {
	const ImgType = (type) => {
		if (type === "supermarket") {
			return "Supermarket";
		} else if (type === "department") {
			return "Department";
		} else if (type === "hospital") {
			return "Hospital";
		} else if (type === "checkpoint") {
			return "Checkpoint";
		} else if (type === "worksite") {
			return "Worksite";
		} else {
			return "Indicator";
		}
	};

	return (
		<div>
			<MapContainer
				center={[23.8859, 45.0792]} // Update center when position changes
				zoom={6}
				minZoom={4}
				maxZoom={18}
				worldCopyJump={false} // Prevents jumping between world copies
				maxBoundsViscosity={1.0} // Prevents dragging outside bounds
				maxBounds={[
					[-90, -180],
					[90, 180],
				]}
				style={{
					height: "calc(100vh - 201px)",
					width: "100%",
					borderRadius: "8px",
				}}
			>
				{" "}
				{LatLng?.lat && LatLng?.lon && LatLng?.zoom && (
					<RecenterMap lat={LatLng.lat} lon={LatLng.lon} zoom={LatLng.zoom} />
				)}
				<MarkerClusterGroup
					chunkedLoading
					spiderfyDistanceMultiplier={1.5} // Add this
					whenCreated={(cluster) => {
						cluster.on("clusterclick", (e) => {
							if (e.layer._spiderfied) {
								e.layer.unspiderfy();
							} else {
								e.layer.spiderfy();
							}
						});
					}}
				>
					{POISdata?.data?.map((i) => {
						const markerName = i?.name || "Unnamed POI";

						const customIcon = L.divIcon({
							className: "custom-marker",
							html: `
		<img src=${process.env.PUBLIC_URL}/assets/New/POIS/${ImgType(
								i?.type
							)}.svg style="width: 32px; height: 32px; position="relative";">
			<div style="top:0; left:65%; background-color:#722ED1; width:24px; height:24px; border:1px solid #D2D5DC; ">
			<img src="/assets/dark/Geofence.svg" style="width: 12px; height: 12px; transform:${
				isRTL ? "translateX(50%)" : "translateX(-50%)"
			}" >
			</div>
			<img>
		<div style="text-align: center; transform:${
			isRTL ? "translateX(50%)" : "translateX(-50%)"
		}">
			<div style="margin-top: 4px; font-size: 14px; color: #000;">${markerName}</div>
		</div>
	`,
							iconSize: [48, 60],
							iconAnchor: [24, 48],
							popupAnchor: [0, -50],
						});

						return (
							<Marker
								key={i.id}
								position={[i.latitude, i.longitude]}
								icon={customIcon}
								rotationOrigin="center"
								interactive={true}
							>
								<Popup closeOnEscapeKey closeButton={false} autoPan={true}>
									<POIsPositionsPopups data={i} setMapId={setMapId} />
								</Popup>
							</Marker>
						);
					})}
				</MarkerClusterGroup>
				<TileLayer url="https://mt0.google.com/vt/lyrs=m,&hl=en&x={x}&y={y}&z={z}&s=Ga" />
				<MapLocationSearch />
			</MapContainer>
		</div>
	);
}
